import { Spinner, Stack, StackProps } from 'component-library';

import { TextAtomProps, TextContainer } from '@/components/widgets/a/Text/Text';

type SpinnerWidgetProps = {
  label?: TextAtomProps;
  size?: number;
} & StackProps;

export const SpinnerWidget = ({ label, size, ...props }: SpinnerWidgetProps) => {
  return (
    <Stack {...props}>
      <Spinner size={size} />
      {label && <TextContainer {...label} />}
    </Stack>
  );
};
